<template>
  <div class="section" v-if="!loading">
    <b>
      You need to verify your email before you can use the website! <br/>
      You have received a 4 digit code on your email, insert it here to verify your email.
    </b>
    <CodeInput class="margin" @complete="tryVerify"/>
    <p class="margin">
      Didn't receive an email? Click
      <button class="button is-primary is-small" @click="resendVerify">Here</button>
      to send another one. <br/>
      <b>Please check your spam folders too.</b>
    </p>
  </div>
  <b-loading :active="loading" v-else/>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import CodeInput from '@/components/CodeInput';

export default {
  components: {
    CodeInput,
  },
  data() {
    return {
      loading: false,
    };
  },

  computed: {
    ...mapState({
      user: state => state.auth.user,
    }),
  },


  methods: {
    ...mapActions({
      emailVerified: 'auth/emailVerified',
    }),
    emailVerifySuccess() {
      this.$router.replace({ name: 'home' });
    },
    async resendVerify() {
      this.loading = true;
      try {
        await this.$http.post('/users/verify_email/');
      } catch (e) {
        this.$toast.open({
          message: 'Could not send a new email, try again later!',
          type: 'is-danger',
        });
      }
      this.loading = false;
    },
    async tryVerify(token) {
      this.loading = true;
      try {
        await this.$http.delete(`/users/verify_email/${token}/`);
        this.loading = false;
      } catch (e) {
        if (e.response.status === 404 || e.response.data.tries_left === '0') {
          await this.resendVerify();
          this.$toast.open({
            message: 'Your previous code has expired! Check your inbox for a new one!',
            type: 'is-danger',
          });
          this.loading = false;
          return;
        }
        if (e.response.status === 400) {
          this.$toast.open({
            message: `Invalid code! ${e.response.data.tries_left} tries left`,
            type: 'is-danger',
          });
          this.loading = false;
          return;
        }

        this.$toast.open({
          message: 'Unknown error occured!',
          type: 'is-danger',
        });
        this.loading = false;
        return;
      }
      await this.emailVerified();
      this.emailVerifySuccess();
    },
  },

  async created() {
    if (this.user.email_verified) {
      this.emailVerifySuccess();
    }
  },
};
</script>

<style lang="scss" scoped>

  .section {
    text-align: center
  }

  .margin {
    margin-top: 1rem;
  }

</style>
